import { Injectable, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { IEventCard } from './models/IEventCard';
import { NotificationModel } from './models/NotificationModel';

export class NgxLiveViewService {
  videoelementSubject: Subject<any> = new Subject<any>();
  eventsCards: Subject<IEventCard> = new Subject<IEventCard>();
  notificationemittor: EventEmitter<NotificationModel> =
    new EventEmitter<any>();

  constructor() {}

  /**
   * The above function is used to pass the video element to the videoGrid component.
   * @param {any} inputPlayVideo - This is the video object that is passed to the service from the
   * component.
   */
  playVideo(inputPlayVideo: any) {
    //console.log("In Service : " , inputPlayVideo)
    this.videoelementSubject.next(inputPlayVideo);
  }
}
